const apiGetAvailableCirculationItems = "/api/moderation/circulation/queue/";
const apiTakeToModeration = "/api/moderation/circulation/queue/";
const apiGetTakenCirculationItems = "/api/moderation/circulation/queue/my/";

const apiGetModerationFromServer = moderationId => `/api/moderation/circulation/queue/my/${moderationId}/`;

const apiModerationResolve = moderationId => `/api/moderation/circulation/queue/my/${moderationId}/resolve/`;

const apiGetUrlCirculationGeneration = (id, type) => `/api/services/circulation/${type}/${id}/generation/`;

export { apiGetAvailableCirculationItems, apiTakeToModeration, apiGetTakenCirculationItems, apiGetModerationFromServer, apiModerationResolve, apiGetUrlCirculationGeneration };